import { SVGProps, Ref, forwardRef } from 'react';

export const EllipsisVerticalOutlinedSize16Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <path
                    d="M8.917 3.25c0 .389-.126.6-.271.72-.156.13-.383.197-.646.197l-.19-.013a.9.9 0 0 1-.456-.183c-.145-.121-.271-.332-.271-.721s.126-.6.271-.72c.156-.13.383-.197.646-.197s.49.067.646.196c.145.121.271.332.271.721Zm0 4.75c0 .389-.126.6-.271.72-.156.13-.383.197-.646.197l-.19-.013a.9.9 0 0 1-.456-.183C7.21 8.6 7.083 8.389 7.083 8s.126-.6.271-.72c.156-.13.383-.197.646-.197s.49.067.646.196c.145.121.271.332.271.721Zm0 4.75c0 .389-.126.6-.271.72-.156.13-.383.197-.646.197s-.49-.067-.646-.196c-.145-.121-.271-.332-.271-.721s.126-.6.271-.72c.156-.13.383-.197.646-.197s.49.067.646.196c.145.121.271.332.271.721Z"
                    fill="currentColor"
                    stroke="currentColor"
                    strokeWidth={0.667}
                />
            </g>
        </svg>
    )
);
EllipsisVerticalOutlinedSize16Glyph.displayName = 'EllipsisVerticalOutlinedSize16Glyph';
